import { useSearchParams } from "react-router-dom";
import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";
import common from "../../../utils/common";

const { encryptAll } = common;

const ENCRYPTION_KEY = import.meta.env.VITE_AES_KEY;

export const fetchKultFetchApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.KULT_FETCH.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const fetchHotlistApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.HOTLIST.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const fetchCandidateApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE_NM.GET_ALL,
    params: {
      ...params,
    },
  });
};
export const addCandidateApi = async (data) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CANDIDATE_NM.ADD,
    data, // For POST requests i am using  "data" instead of "params"
  });
};

const urlMap = {
  Submission: ENDPOINTS.SUBMISSION_NM.GET_TOTAL_COUNT_SUBMISSION,
  Interview: ENDPOINTS.INTERVIEW_NM.GET_TOTAL_COUNT_INTERVIEWS,
  Placement: ENDPOINTS.PLACEMENT_NM.GET_TOTAL_COUNT_PLACEMENTS,
  Candidate: ENDPOINTS.CANDIDATE_NM.GET_TOTAL_COUNT_CANDIDATE,
};

export const fetchTotalCountApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: urlMap[params.coll],
    params: {
      ...params,
    },
  });
};

export const updateCandidateApi = async (uiid, data) => {
  const isFormData = data instanceof FormData;

  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.CANDIDATE_NM.UPDATE,
    params: {
      uiid,
      coll: "Candidate",
      uploadType: "multiple",
      field: "file",
    },
    data,
    //  Let Axios set multipart boundaries automatically
    headers: isFormData ? {} : { "Content-Type": "application/json" },
  });
};

export const uploadDocumentApi = async (formData, params = {}) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CANDIDATE_NM.UPLOAD,
    params: {
      ...params, // query params like coll, uploadType, field
    },
    data: formData, //  FormData contains files
    headers: {
      "Content-Type": "multipart/form-data", // Let axios handle boundary automatically
    },
  });
};

export const fetchUsersApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.USEREF_NM.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const getTotalUserCountApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.USEREF_NM.GET_TOTAL_COUNT,
    params: {
      ...params,
    },
  });
};

export const getTotalEmailCountApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.EMAILACCOUNT_NM.GET_TOTAL_COUNT,
    params: {
      ...params,
    },
  });
};

export const addJobContactApi = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.CONTACTS_NM.ADD,
    data,
  });
};

export const fetchCompanyContactApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CONTACTS_NM.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const addSubmissionDetailsApi = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.SUBMISSION_NM.ADD,
    data,
  });
};

export const fetchSubmissionDetailsApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.SUBMISSION_NM.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const addInterviewDetailsApi = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.INTERVIEW_NM.ADD,
    data,
  });
};

export const fetchInterviewDetailsApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTERVIEW_NM.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const addPlacementDetailsApi = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.PLACEMENT_NM.ADD,
    data,
  });
};

export const getCandidateScore = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.CANDIDATE_NM.GET,
  });
};

export const handleAnalyzeApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE_NM.ANALYZE,
    params: {
      ...params,
    },
  });
};

export const fetchCandidateVersionApi = async (params) => {
  return axiosRequest({
    url: ENDPOINTS.CANDIDATEVERSION_NM.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const fetchResumeDetailsApi = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.OPTIMISERESUME_NM.GET_ALL,
    data,
  });
};

export const fetchDraftDetailsApi = async (data) => {
  return axiosRequest({
    method: "POST",
    url: ENDPOINTS.AIDRAFT_NM.GET_ALL,
    data,
  });
};

export const deleteCandidateVersionApi = async (data) => {
  return axiosRequest({
    method: "DELETE",
    url: ENDPOINTS.CANDIDATEVERSION_NM.DELETE,
    data,
  });
};

export const getRecruiterAssignedCandidatedApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE_NM.GET_TOTAL_USER_COUNT,
    params: {
      ...params,
    },
  });
};

export const BenchSalesResumeParser = async (formData) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.CANDIDATE_NM.RESUME_PARSER}?uploadType=single`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getRecruitersUiidApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.USEREF_NM.GET_ALL,
    params,
  });
};

export const updateContactApi = async (params) => {
  const { data, ...queryParams } = params;

  return axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.CONTACTS_NM.UPDATE,
    params: queryParams,
    data,
  });
};

export const fetchIntegrationAccess = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.NM_INTEGRATION_ACCESS.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const getAllIntegrationsNm = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTEGRATION_NM.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const addIntegrationsNm = async (params) => {
  const { config, ...rest } = params?.payload;
  const payload = { ...rest, ...config };
  const data = { coll: params?.coll, payload };

  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INTEGRATION_NM.ADD,
    data: data,
  });
};

export const updateIntegrationsBsMail = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    // url: `${ENDPOINTS.INTEGRATION_BS.UPDATE}?coll=Integrationbs&uiid=${params.uiid}`,
    url: `${ENDPOINTS.NM_AUTH.UPDATE}?coll=AuthToken&email=${params.email}`,

    data: {
      payload: params.payload,
    },
  });
};

export const deleteIntegrationBs = async (params) => {
  return await axiosRequest({
    method: "DELETE",
    url: `${ENDPOINTS.INTEGRATION_NM.DELETE}`,
    data: {
      coll: params.coll,
      uiid: params.uiid,
    },
  });
};

export const deleteIntegrationBsMail = async (params) => {
  return await axiosRequest({
    method: "DELETE",
    url: `${ENDPOINTS.EMAILACCOUNT_NM.DELETE}`,
    data: {
      coll: params.coll,
      uiid: params.uiid,
    },
  });
};
export const getAllIntegrationAccessNm = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTEGRATION_ACCESS_NM.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.fil),
      useAggregate: params.useAggregate,
      ref: params.ref,
      incl: params.incl,
      lim: params.lim,
      pg: params.pg,
      queryMode: params.queryMode,
    },
  });
};
export const getemailAccessBs = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.EMAILACCOUNT_NM.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.fil),
      useAggregate: params.useAggregate,
      ref: params.ref,
      incl: params.incl,
      lim: params.lim,
      pg: params.pg,
      queryMode: params.queryMode,
    },
  });
};

export const addUsersIntegrationAccessNm = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INTEGRATION_ACCESS_NM.ADD,
    data: params,
  });
};

export const updateIntegrationAccessStatusNm = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.INTEGRATION_ACCESS_NM.UPDATE}?coll=Integrationaccess&uiid=${params.uiid}`,
    data: {
      payload: params.payload,
    },
  });
};

export const updateIntegrationAccessStatusNmMail = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.EMAILACCOUNT_NM.UPDATE}?coll=EmailAccount&email=${params.email}&uiid=${params.uiid}`,
    data: {
      payload: params.payload,
    },
  });
};

export const updateIntegrationsNm = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.INTEGRATION_NM.UPDATE}?coll=Integrationbs&uiid=${params.uiid}`,
    // url: `${ENDPOINTS.NM_AUTH.UPDATE}?coll=AuthToken&email=${params.email}`,

    data: {
      payload: params.payload,
    },
  });
};

export const addCreditHistoryNm = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CREDIT_HISTORY_NM.ADD,
    data: params,
  });
};

export const getAllCreditHistoryBs = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CREDIT_HISTORY_NM.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const getTotalMainCountApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTERVIEW_NM.GET_TOTAL_MAIN_COUNT,
    params: {
      ...params,
    },
  });
};

export const verifyEmail = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CONTACTS_NM.VERIFY,
    data: params,
  });
};

export const addCandidatePlatformCredentialApi = async (params) => {
  const { config, ...rest } = params?.payload || {};
  const payload = { ...rest, ...config };

  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.CANDIDATE_PLATFORM_CREDENTIALS_NM.ADD,
    params: {
      coll: "candidatePlatformCredential",
    },
    data: {
      coll: "candidatePlatformCredential",
      payload: payload,
    },
  });
};

export const fetchCandidatePlatformCredentialsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE_PLATFORM_CREDENTIALS_NM.GET_ALL,
    params: {
      ...params,
    },
  });
};
export const updateCandidatePlatformCredentialsApi = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.CANDIDATE_PLATFORM_CREDENTIALS_NM.UPDATE,
    params: {
      ...params,
    },
    data: {
      payload: params?.payload,
    },
  });
};

export const apolloAuthApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.NM_CONTACTS.AUTH,
    params: {
      ...params,
    },
  });
};

export const getCandidateDoc = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE_NM.GET_DOC,
    params: {
      ...params,
    },
  });
};

export const getSettingsBs = async () => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.SETTINGS_NM.GET_ALL,
  });
};

export const getAssignedCandidateApi = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE_NM.GET_TOTAL_USER_COUNT,
    params: {
      ...params,
    },
  });
};

export const getOnprojectCandidateAPI = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE_NM.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const getCandidateById = async (params) => {
  return axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATE_NM.GET_BY_ID,
    params: {
      ...params,
    },
  });
};

export const getGmailAccountsBs = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.NM_GMAIL.GET_GMAIL,
    params: {
      ...params,
    },
  });
};

export const getOutlookAccountsBs = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.NM_OUTLOOK.GET_OUTLOOK,
    params: {
      ...params,
    },
  });
};

export const assignAccessToEmailAccountBS = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.NM_MAIL_ACCOUNT.ASSIGN_ACCESS,
    data: {
      ...params,
    },
  });
};

export const getEmailAccountCountBs = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.EMAILACCOUNT_NM.GET_TOTAL_COUNT,
    params: {
      ...params,
    },
  });
};

export const deleteCandidateApi = async (params) => {
  return await axiosRequest({
    method: "DELETE",
    url: ENDPOINTS.CANDIDATE_NM.DELETE,
    data: params,
  });
};

export const getGmailAuthAPI = async (params) => {
  window.location.href = ENDPOINTS.NM_GMAIL.GMAIL_AUTH;
};

export const getOutlookAuthAPI = async (params) => {
  window.location.href = ENDPOINTS.NM_OUTLOOK.OUTLOOK_AUTH;
};
